var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"team-ci-cd-settings-form mt-3"},[_c('project-ci-cd-settings-form-table',{key:_vm.ciCdVariablesTableComponentKey,attrs:{"alias":_vm.alias,"form-name":_vm.TEAM_SETTING_CI_CD_FORM,"existing-variables":_vm.existingVariables},on:{"submit":_vm.submitForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }